module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_7016.85c08ee0.png";